import React, { useState, useRef } from 'react'
import { Icon, Input, Spin, Modal, Button, message, Tag, notification } from "antd"
import { listBatchesV4, groupBatch } from '../../../services/api/3dApi'
import { NavLink } from 'react-router-dom'
import _ from 'lodash'

const GroupBatchPage = () => {
    const _input = useRef()
    const [loading, setLoading] = useState(false)
    const [valueInput, setValueInput] = useState('')
    const [errorInput, setErrorInput] = useState('')
    const [listBatch, setListBatch] = useState([])

    const _onSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)

        // 1. Parse input
        const batchNames = valueInput
            .split(/[,\s]+/)
            .map(x => x.trim())
            .filter(Boolean)

        if (!batchNames.length) {
            setErrorInput('Vui lòng nhập mã lô.')
            setLoading(false)
            return
        }

        const regex = /^\w+-\d/

        // 2. Check format
        const invalidFormat = batchNames.filter(name => !regex.test(name))
        const validNames = batchNames.filter(name => regex.test(name))

        try {
            const { data } = await listBatchesV4({
                name: { $in: validNames }
            })

            const batches = _.get(data, 'data.batches') || []

            // 3. Không tồn tại trong DB
            const foundNames = batches.map(b => b.name)
            const notFound = validNames.filter(n => !foundNames.includes(n))

            // 4. Sai trạng thái
            const invalidStatus = batches.filter(b => b.status !== 'pending')

            // 5. Lấy lô hợp lệ trước
            const validBatches = batches.filter(b => b.status === 'pending')

            // 6. Check cùng NVL
            let sameMaterialBatches = []
            let differentMaterial = []

            if (validBatches.length) {
                const material = _.get(validBatches[0], 'preference.sku.materials')
                sameMaterialBatches = validBatches.filter(b => _.get(b, 'preference.sku.materials') === material)
                differentMaterial = validBatches.filter(b => _.get(b, 'preference.sku.materials') !== material)
            }

            // 7. Merge với list hiện tại + unique
            const merged = [
                ...new Map([...listBatch, ...sameMaterialBatches].map(b => [b._id, b])).values()
            ]

            if (merged.length) {
                setListBatch(merged)
            }

            // 9. Hiển thị lỗi chi tiết
            const errors = []

            if (invalidFormat.length)
                errors.push(`Sai định dạng: ${invalidFormat.join(', ')}`)

            if (notFound.length)
                errors.push(`Không tồn tại: ${notFound.join(', ')}`)

            if (invalidStatus.length)
                errors.push(
                    `Sai trạng thái: ${invalidStatus.map(b => `${b.name} (${b.status})`).join(', ')}`
                )

            if (differentMaterial.length)
                errors.push(
                    `Khác nguyên vật liệu: ${differentMaterial.map(b => b.name).join(', ')}`
                )

            if (errors.length) {
                Modal.error({
                    title: 'Một số lô không hợp lệ',
                    content: <div>
                        {errors.map((e, i) => (
                            <div key={i}>• {e}</div>
                        ))}
                    </div>
                })
            }

        } catch (error) {
            setErrorInput(error.message)
        } finally {
            setLoading(false)
            setValueInput('')
            _input.current.focus()
        }
    }

    const _removeBatch = (batchId) => {
        const newBatchs = listBatch.filter(batch => batch._id !== batchId) || []
        setListBatch(newBatchs)
    }

    const _resetScanInput = () => {
        setValueInput('')
        _input.current.focus()
    }

    const _handleChangeScan = e => {
        setValueInput(e.target.value)
        setErrorInput('')
    }

    const _handleGroupBatch = async () => {
        setLoading(true)
        try {
            if (listBatch.length < 2) return Modal.error({
                title: 'Lỗi',
                content: 'Gom nhóm tối thiểu 2 lô.',
            })

            const payload = {
                batch_ids: listBatch
            }

            const { data = {} } = await groupBatch(payload)
            const { success, error } = data

            if (!success) throw new Error(error)

            message.success("Gom nhóm lô thành công.")
            setListBatch([])
            _resetScanInput()
            setErrorInput('')

        } catch (error) {
            Modal.error({
                title: 'Lỗi',
                content: error.message,
            })
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className='GroupBatchPage py-5'>
            <div className="col-12 mx-auto px-5">
                <div className="d-flex align-items-baseline justify-content-between">
                    <h1>
                        Gom nhóm lô
                    </h1>
                    <label className="border rounded cursor-pointer font-weight-bold py-2 px-4 bg-white h6">
                        <NavLink exact to='/list-group-batch' className='nav-link p-0'>
                            Danh sách nhóm lô
                        </NavLink>
                    </label>
                </div>
                <div className="position-relative">
                    <Spin spinning={loading} tip='Đang kiểm tra...'>
                        <form onSubmit={_onSubmit} className="formQC">
                            <Input
                                value={valueInput.toUpperCase()}
                                style={{ fontSize: 40, height: "auto" }}
                                ref={_input}
                                autoFocus={true}
                                placeholder='Nhập vào tên lô'
                                onChange={_handleChangeScan}
                            />

                            {
                                valueInput &&
                                <Icon
                                    type='close-circle'
                                    className="position-absolute cursor-pointer text-dark IconInput"
                                    onClick={_resetScanInput}
                                />
                            }

                            {
                                loading &&
                                <Icon type="sync" spin className="position-absolute IconInput" />
                            }

                            <div className="d-flex justify-content-between align-items-center">
                                <div className="batch_tag">
                                    {
                                        !!listBatch.length &&
                                        listBatch.map((batch) => {
                                            return (
                                                <Tag
                                                    key={batch._id}
                                                    closable
                                                    onClose={() => _removeBatch(batch._id)}
                                                >{batch.name}
                                                </Tag>
                                            )
                                        })
                                    }
                                </div>
                                <div>
                                    {
                                        !loading && !!listBatch.length &&
                                        <Button
                                            type='primary'
                                            className='float-right mt-3 px-4'
                                            onClick={_handleGroupBatch}
                                        >
                                            Gom nhóm
                                        </Button>
                                    }
                                </div>
                            </div>
                        </form>

                        {errorInput && <div className="text-danger mt-3">{errorInput}</div>}
                    </Spin>
                </div>
            </div>
        </div>
    )
}

export default GroupBatchPage